var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "layer_section layer-area type-wide-a",
      attrs: { id: "aboPopup" }
    },
    [
      _c("div", { staticClass: "layer_section-container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "align-box size-auto" }, [
          _c(
            "button",
            {
              staticClass: "btn-modal_close",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("layer")
                }
              }
            },
            [_vm._v("확인")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layer-content campaign-detail" }, [
      _c("h2", { staticClass: "campaign-detail__title" }, [
        _vm._v("\n                신규 ABO 후원 장려 캠페인 "),
        _c("br", { staticClass: "mobile" }),
        _vm._v("달성조건 안내\n            ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "abo-guide" }, [
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v("1. 캠페인 기간: 2021년 3월 ~ 5월")
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "abo-build__list" }, [
            _c("li", [_vm._v(" 3월: 3월 1일 (월) ~ 3월 31일 (수)")]),
            _vm._v(" "),
            _c("li", [_vm._v(" 4월: 4월 1일 (목) ~ 4월 30일 (금)")]),
            _vm._v(" "),
            _c("li", [_vm._v(" 5월: 5월 1일 (토) ~ 5월 31일 (월)")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                        2. 캠페인 대상자\n                    "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "abo-build__list" }, [
            _c("li", [
              _vm._v(
                "\n                             해당 월 유자격 플래티넘 이상 리더\n                            [예: 4월 대상자 = 4월 1일 부 유자격 플래티넘 이상 리더]\n                        "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                             캠페인 대상자인 유자격 플래티넘 이상 리더가 월 중간 탈퇴할 경우, 캠페인 대상자가 없는 관계로 대상 제외\n                        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                        3. 캠페인 달성 시 지급\n                    "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "abo-build__list" }, [
            _c("li", [
              _vm._v(
                "\n                             A Cliks Money 10만원 (매 익월 중순 지급 예정)\n                        "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                             A Cliks Money 지급 시 윤리 강령 이슈 대상자 제외\n                            [예: 4월 캠페인 달성 시, 5월 중순 지급 (단, 5월 윤리 강령\n                            이슈 대상자는 지급에서 제외)]\n                        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                        4. 캠페인 달성 조건\n                    "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "abo-build__list" }, [
            _c("li", [
              _vm._v(
                "\n                            해당 월 본인 유자격 PT그룹 내 * 신규ABO(아래 기준 충족한 리더) 10조 이상 후원한 리더\n                        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "abo-build__title__sub" }, [
            _vm._v(
              "\n                        * 신규 ABO 기준\n                    "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "abo-build__list" }, [
            _c("li", [
              _vm._v(
                "\n                             해당 월 가입 + 해당 월 누적 10만원 이상 구매 한 자 (최종 결제 금액 기준 누적 10만원이상)\n                        "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                             ABO로서 구매한 금액만 인정되며, 월 마감 시 자격이 ABO인 자만 인정 (멤버나 소비자 제외)"
              ),
              _c("br"),
              _vm._v(
                "\n                            (예: 멤버나 소비자로 가입 후 ABO로 전환 시, 멤버나 소비자인 자격으로 구매한 금액은 불인정)"
              ),
              _c("br"),
              _vm._v(
                "\n                            (예: 멤버나 소비자가 구매 후 ABO에게 실적 이관 건 불인정)\n                        "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                             모든 제품 구매에 한하며, 1회 구매 금액 하한가/상한가 없음\n                        "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(" 주문 기준이며, 반품이나 배송상태는 고려하지 않음")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v(" 위 조건을 달성한 후 탈퇴해도 인정됨")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                " ARS 주문 시 1% 할인 적용될 경우, 적용 후 최종 결제 금액 기준으로 10만원 이상이어야 함"
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "abo-guide__block" }, [
          _c("h3", { staticClass: "abo-build__title" }, [
            _vm._v(
              "\n                        5. 신규 ABO 후원 장려 캠페인 ‘대시보드’ 안내\n                    "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "abo-build__list" }, [
            _c("li", [
              _vm._v(
                "\n                             유자격 PT 그룹 및 핀 재 산정으로 인해 매월 중순부터 확인 가능 (핀 재 산정으로 월 중순에 추가 된 경우, 이미 마감된 이전 캠페인의 데이터는 확인 불가)\n                        "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                             매일 오전 10시 이후 전일 오전 12시 이전까지 내용 업데이트\n                        "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                             신규 가입 ABO 정보는 가입 시 개인정보 제공 동의 기준으로 비 식별 처리될 수 있음\n                        "
              )
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53483f1a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53483f1a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sales/dashboard/component/layerAttainment.vue
// module id = null
// module chunks = 